import { render } from "./B2bTableMenuRemadv.vue?vue&type=template&id=65d8dd30&scoped=true&lang=pug"
import script from "./B2bTableMenuRemadv.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuRemadv.vue?vue&type=script&lang=js"

import "./B2bTableMenuRemadv.vue?vue&type=style&index=0&id=65d8dd30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d8dd30"]])

export default __exports__